import { ReactElement } from 'react'
import { ProjectImplementationDetailsIndex } from 'src/screens/shared/implementation/details/ProjectImplementationDetailsIndex'

export const PfKapImplementationDetailsIndexPage = (): ReactElement => {
  return <ProjectImplementationDetailsIndex baseUrl="/pf-kap" />
}
